import {
    SET_LOADING,
    SET_ERROR,
    LOADED_SCOPE,
    CLEAR_ALL_AUTH_STATE,
    LOADED_AUTH_STATE,
    CLEAR_AUTH_STATE,
    LOADED_TOKEN,
    REMOVE_TOKEN,
} from "./auth.types";
import { StorageService } from "@/services";

export default (state, action) => {
    switch (action.type) {
        case LOADED_AUTH_STATE:
            return {
                ...state,
                isAuthReady: true,
                isAuthenticated: action.payload.isAuthenticated,
                isAdmin: action.payload.isAdmin,
                isUser: action.payload.isUser,

                user: action.payload.user,
                userId: action.payload.userId,
                userName: action.payload.userName,
                userEmail: action.payload.userEmail,
                userPhone: action.payload.userPhone,
                userType: action.payload.userType,
                userOfficeLevel: action.payload.userOfficeLevel,
                userSignature: action.payload.userSignature,
                userNid: action.payload.userNid,
                isUserNidVerified: action.payload.isUserNidVerified,
                userNidVerificationAttempt: action.payload.userNidVerificationAttempt,

                profileId: action.payload.profileId,
                profileNameEn: action.payload.profileNameEn,
                profileNameBn: action.payload.profileNameBn,
                profileType: action.payload.profileType,
                profileImage: action.payload.profileImage,

                employeeId: action.payload.employeeId,
                dealerId: action.payload.dealerId,
                supervisorId: action.payload.supervisorId,
                designationId: action.payload.designationId,
                designationEn: action.payload.designationEn,
                designationBn: action.payload.designationBn,
                organogramDesignationId: action.payload.organogramDesignationId,

                organizationId: action.payload.organizationId,
                workOrganizationId: action.payload.workOrganizationId,
                organizationNameEn: action.payload.organizationNameEn,
                organizationNameBn: action.payload.organizationNameBn,
                organizationIds: action.payload.organizationIds,

                organogramId: action.payload.organogramId,
                workOrganogramId: action.payload.workOrganogramId,
                organogramType: action.payload.organogramType,
                organogramNameEn: action.payload.organogramNameEn,
                organogramNameBn: action.payload.organogramNameBn,
                organogramIds: action.payload.organogramIds,

                groupIds: action.payload.groupIds,
                groupNameList: action.payload.groupNameList,
                groupCodeList: action.payload.groupCodeList,

                roleIds: action.payload.roleIds,
                roleNameList: action.payload.roleNameList,
                roleCodeList: action.payload.roleCodeList,

                divisionId: action.payload.divisionId,
                regionId: action.payload.regionId,
                districtId: action.payload.districtId,
                thanaId: action.payload.thanaId,
                unionId: action.payload.unionId,
                blockId: action.payload.blockId,
                riceCropId: action.payload.riceCropId,
                currentRiceSeasonId: action.payload.currentRiceSeasonId,
                currentCropSeasonId: action.payload.currentCropSeasonId,
                currentFinancialYearId: action.payload.currentFinancialYearId,
                currentFinancialYearTitle: action.payload.currentFinancialYearTitle,
                nextFinancialYearId: action.payload.nextFinancialYearId,
                nextFinancialYearTitle: action.payload.nextFinancialYearTitle,
                loading: false,
                error: false,
            };

        case LOADED_SCOPE:
            return {
                ...state,
                scopes: action.payload.scopes,
            };

        case LOADED_TOKEN:
            StorageService.setAccessToken(action.payload.accessToken);
            StorageService.setRefreshToken(action.payload.refreshToken);
            return {
                ...state,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
            };

        case REMOVE_TOKEN:
            StorageService.removeAccessToken();
            StorageService.removeRefreshToken();
            return {
                ...state,
                isAuthReady: true,
                isAuthenticated: false,
                isAdmin: false,
                isUser: false,
                accessToken: null,
                refreshToken: null,
            };

        case CLEAR_AUTH_STATE:
            return {
                ...state,
                isAuthReady: true,
                isAuthenticated: false,
                isAdmin: false,
                isUser: false,
                user: null,
                userId: null,
                scopes: null,
                loading: false,
                error: null,
            };

        case CLEAR_ALL_AUTH_STATE:
            return {
                ...state,
                isAuthReady: true,
                isAuthenticated: false,
                isAdmin: false,
                isUser: false,
                user: null,
                userId: null,
                userName: null,
                userType: null,
                userNid: null,
                isUserNidVerified: false,
                userNidVerificationAttempt: 0,
                profileId: null,
                profileNameEn: null,
                profileNameBn: null,
                profileType: null,
                profileImage: null,
                departmentId: null,
                designationId: null,
                designationEn: null,
                designationBn: null,
                groupIds: null,
                groupNameList: null,
                groupCodeList: null,
                roleIds: null,
                roleNameList: null,
                roleCodeList: null,
                scopes: null,
                organogramId: null,
                organogramIds: null,
                organogramNameEn: null,
                organogramNameBn: null,
                organizationId: null,
                organizationIds: null,
                organizationNameEn: null,
                organizationNameBn: null,
                employeeId: null,
                orgOrganogramDesignationId: null,
                loading: false,
                error: null,
            };

        case SET_LOADING:
            return {
                ...state,
                loading: action.payload.loading,
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload.error,
            };

        default:
            return state;
    }
};
